import { io } from "socket.io-client";
import React from 'react';
import { connect } from "react-redux";
import { setUserLogout } from '../actions/logout';
import { getUnreadThreadsQuery, getThreadQuery, getUnreadThreadsCountQuery, getAllThreadsQuery } from '../helpers/socket/socketActions';
import { socketUrl } from '../config';

const secure = socketUrl && socketUrl.indexOf('https://') >= 0 ? true : false;

export const socket = io(socketUrl,
    {
        secure,
        upgrade: true,
        transports: ['websocket'],
        reconnection: true,
        forceNew: true,
        rejectUnauthorized: false
    }
);
class SocketProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null
        };
    }   

    componentDidMount = () => {
        const { userId, getUnreadThreadsQuery, getThreadQuery, getUnreadThreadsCountQuery, getAllThreadsQuery, setUserLogout } = this.props;

        socket.on(`viewMessage-${userId}`, (data) => {
            getThreadQuery({ type: 'host', threadId: data?.data?.threadId });
            getThreadQuery({ type: 'guest', threadId: data?.data?.threadId });
            getAllThreadsQuery();
            getUnreadThreadsQuery();
            getUnreadThreadsCountQuery();
        })

        socket.on(`userLogout-${userId}`, () => {
            setUserLogout({ isAdmin: false });
            this.setState({ id: userId });
        });
    }

    componentDidUpdate = () => {
        const { userId, getUnreadThreadsQuery, getUnreadThreadsCountQuery } = this.props;

        socket.on(`viewMessage-${userId}`, (data) => {
            getUnreadThreadsQuery();
            getUnreadThreadsCountQuery();
        })
    }

    componentWillUnmount() {
        const { id } = this.state;
        if (id) {
            socket.off(`userLogout-${id}`);
            socket.off(`viewMessage-${id}`);
        }
    }

    render() {
        const { userId, adminId, setUserLogout } = this.props;

        socket.on(`userLogout-${userId}`, () => {
            setUserLogout({ isAdmin: false });
            this.setState({ id: userId });
        });
        return (
            <>
            </>)
    }
}

const mapState = (state) => ({
    userId: state?.account?.data?.userId,
    adminId: state?.adminPrevileges?.privileges?.id
});

const mapDispatch = {
    setUserLogout,
    getUnreadThreadsQuery,
    getThreadQuery,
    getUnreadThreadsCountQuery,
    getAllThreadsQuery
};
export default (connect(mapState, mapDispatch)(SocketProvider));